import React, { useMemo } from 'react';
import { useUncategorizedEventSchedule } from '../../../../../../data/hooks/schedule/useUncategorizedEventSchedule';
import GroupedProgramItems from '../../../common/GroupedProgramItems';
import { mergeProgramAndSchedule } from '../../../mergeProgramAndSchedule';
import useScheduleMeetings from '../../../useScheduleMeetings/useScheduleMeetings';

function ScheduleProgram(props) {
    const { event, date, dateFilter, focusedRoundId } = props,
        sessions = useUncategorizedEventSchedule(event.id, {
            filter: dateFilter,
        }),
        meetings = useScheduleMeetings(event.id, {
            filter: dateFilter,
        }),
        mergedItems = useMemo(() => mergeProgramAndSchedule(sessions, meetings), [sessions, meetings]);

    return <GroupedProgramItems event={event} items={mergedItems} focusedRoundId={focusedRoundId} />;
}

export default ScheduleProgram;
